import { Loader2 } from 'lucide-react';

interface PageLoaderProps {
  fullScreen?: boolean;
  message?: string;
}

export function PageLoader({ fullScreen = true, message = 'Loading...' }: PageLoaderProps) {
  return (
    <div
      className={`flex items-center justify-center ${
        fullScreen ? 'h-screen w-full' : 'h-64 w-full'
      } bg-background/50`}
    >
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-10 w-10 animate-spin text-[#A855F7]" />
        <p className="text-sm text-[#6B6B6B]">{message}</p>
      </div>
    </div>
  );
}

// Skeleton loader for Dashboard
export function DashboardSkeleton() {
  return (
    <div className="p-6 space-y-6 animate-pulse">
      <div className="h-8 bg-[#F7F7F7] rounded w-1/4" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="h-32 bg-[#F7F7F7] rounded-lg" />
        ))}
      </div>
      <div className="h-64 bg-[#F7F7F7] rounded-lg" />
    </div>
  );
}

// Skeleton loader for Calendar
export function CalendarSkeleton() {
  return (
    <div className="p-6 space-y-4 animate-pulse">
      <div className="h-10 bg-[#F7F7F7] rounded w-1/3" />
      <div className="grid grid-cols-7 gap-2">
        {Array.from({ length: 35 }).map((_, i) => (
          <div key={i} className="h-24 bg-[#F7F7F7] rounded" />
        ))}
      </div>
    </div>
  );
}

// Skeleton loader for Content
export function ContentSkeleton() {
  return (
    <div className="p-6 space-y-4 animate-pulse">
      <div className="h-8 bg-[#F7F7F7] rounded w-1/4" />
      <div className="flex gap-4 overflow-x-auto">
        {[1, 2, 3].map(i => (
          <div key={i} className="flex-shrink-0 w-80 h-96 bg-[#F7F7F7] rounded-lg" />
        ))}
      </div>
    </div>
  );
}
